module.exports = __webpack_public_path__ + "img/accidental-loss.8e6f8be8.png";